import { useState, useEffect, useRef } from 'preact/hooks'

import cn from 'classnames'

import styles from './PhoneCodeSelect.module.css'
import flags from './flags.module.css'

const PhoneCodeSelect = ({
  countryData,
  selectedCountry,
  setSelectedCountry,
  handleSearch,
  filteredData,
  setFilteredData,
}) => {
  const [showList, setShowList] = useState(false)
  const searchInput = useRef(null)

  useEffect(() => {
    if (!showList) {
      setFilteredData(null)
      searchInput.current.value = ''
    }
  }, [showList, setFilteredData])

  useEffect(() => {
    ;[`click`, `touchstart`].forEach((type) => {
      document.addEventListener(type, outsideHandler)
    })
    return () => {
      ;[`click`, `touchstart`].forEach((type) => {
        document.removeEventListener(type, outsideHandler)
      })
    }
  }, [])

  const outsideHandler = (e) => {
    if (
      e.target.classList.contains(styles.phoneCode) ||
      e.target
        .closest(`.${styles.phoneCode}`)
        ?.classList.contains(styles.phoneCode)
    ) {
      return
    }
    setShowList(false)
  }

  const countryAbbr = selectedCountry.code
  const flagClass = [flags.flag, flags[countryAbbr.toLowerCase()]].join(' ')

  const countryHandler = (code) => {
    const find = countryData.find((country) => country.code === code)
    setSelectedCountry(find)
    setShowList(false)
  }

  const renderCountryList = (countries) => {
    return countries.map((country) => (
      <div
        className={styles.phoneCode__countryElement}
        key={country.country_id}
        onClick={() => countryHandler(country.code)}
      >
        <span className={[flags.f32, styles.phoneCode__flag].join(' ')}>
          <span
            className={[flags.flag, flags[country.code.toLowerCase()]].join(
              ' '
            )}
          />
        </span>
        <span className={styles.phoneCode__countryName}>
          {country.name.toUpperCase()}
        </span>
        <span className={styles.phoneCode__countryCode}>
          {country.phone_code}
        </span>
      </div>
    ))
  }

  return (
    <div className={styles.phoneCode}>
      <div
        className={[styles.phoneCode__selectedFlag, flags.f32].join(' ')}
        onClick={() => setShowList(!showList)}
      >
        <span className={styles.phoneCode__flag}>
          <span className={flagClass} />
        </span>
        {countryAbbr}
      </div>
      <div
        className={cn(styles.phoneCode__countryList, {
          [styles.phoneCode__countryList_visible]: showList,
        })}
      >
        <div className={styles.phoneCode__countryElement}>
          <input
            ref={searchInput}
            type="text"
            placeholder="Поиск"
            onChange={handleSearch}
          />
        </div>
        {filteredData
          ? renderCountryList(filteredData)
          : renderCountryList(countryData)}
      </div>
    </div>
  )
}

export default PhoneCodeSelect
